import { FormInstance } from 'antd'
import { SagaIterator } from 'redux-saga'
import { call, fork, put, takeLatest } from 'redux-saga/effects'
import {
  ACTIVATE_NURSE,
  ADD_NURSE,
  CHANGE_NURSE_ROLE,
  DELETE_NURSE,
  GET_NURSE,
  GET_NURSES,
  SET_UPDATE_NURSE,
  UPDATE_NURSE,
} from './actionTypes'
import {
  activateNurseData,
  addNurseData,
  changeNurseRoleData,
  deleteNurseData,
  getNurseData,
  getNursesData,
  updateNurseData,
} from './api'
import {
  addNurse,
  addNurseSucess,
  addNurses,
  deleteNurseSuccess,
  errorNurse,
  getNurses,
  setNurseForUpdateSuccess,
  successNurse,
  updateNurseSuccess,
} from './nurseReducer'
import { GetNurseDataType, Nurse, NurseDataType } from './types'

type Action = {
  type: string
  payload: string
}

type postAction = {
  type: string
  payload: Nurse
}

export function* handleGetNurseData(actions: Action): SagaIterator<void> {
  try {
    const response = yield call(getNurseData, actions.payload)
    const { data } = response
    yield put(addNurse(data))
    yield put(getNurses())
  } catch (error: any) {
    yield put(errorNurse(error.response.data.message))
  }
}

export function* handleGetNursesData(): SagaIterator<void> {
  try {
    const response = yield call(getNursesData)
    const { data } = response
    let unmodifiedData = data.nurses
    let newData: Nurse[] = unmodifiedData.map((data: NurseDataType) => {
      let newData: Nurse = {
        nurseId: data.nurseId,
        nurseKey: data.nurseKey,
        emailId: data.email,
        firstName: data.firstName,
        lastName: data.lastName,
        isSupervisor: data.isSupervisor,
        jobTitle: data.jobTitle,
        phonePrimary: data.phone1,
        phoneSecondary: data.phone2,
        title: data.title,
        isActive: data.isActive,
      }
      return newData
    })
    yield put(addNurses(newData))
  } catch (error: any) {
    yield put(errorNurse(error.response.data.message))
  }
}

export function* handleDeleteNurseData(actions: Action): SagaIterator<void> {
  try {
    const response = yield call(deleteNurseData, actions.payload)
    yield put(deleteNurseSuccess(actions.payload))
    yield put(getNurses())
    const { data } = response
    yield put(successNurse(data.status))
  } catch (error: any) {
    yield put(errorNurse(error.response.data.message))
  }
}

export function* handleAddNurseData(actions: postAction): SagaIterator<void> {
  try {
    const response = yield call(addNurseData, actions.payload)
    const { data } = response
    const newNurseData = {
      ...actions.payload,
      nurseKey: data.nurseKey,
    }
    yield put(addNurseSucess(newNurseData))
    yield put(getNurses())
    yield put(successNurse(data.status))
  } catch (error: any) {
    yield put(errorNurse(error.response.data.message))
  }
}

export function* handleUpdateNurseData(
  actions: postAction
): SagaIterator<void> {
  try {
    const response = yield call(
      updateNurseData,
      actions.payload.nurseKey,
      actions.payload
    )
    const { data } = response
    yield put(updateNurseSuccess(actions.payload))
    yield put(getNurses())
    yield put(successNurse(data.status))
  } catch (error: any) {
    yield put(errorNurse(error.response.data.message))
  }
}

export function* handleActivateNurseData(actions: Action): SagaIterator<void> {
  try {
    const response = yield call(activateNurseData, actions.payload)
    yield put(getNurses())
    const { data } = response
    yield put(successNurse(data.status))
  } catch (error: any) {
    yield put(errorNurse(error.response.data.message))
  }
}

type ChangeNurseRoleDataAction = {
  type: string
  payload: {
    id: string
    role: string
  }
}

export function* handleChangeNurseRoleData(
  actions: ChangeNurseRoleDataAction
): SagaIterator<void> {
  try {
    const response = yield call(
      changeNurseRoleData,
      actions.payload.id,
      actions.payload.role
    )
    yield put(getNurses())
    const { data } = response
    yield put(successNurse(data.status))
  } catch (error: any) {
    yield put(errorNurse(error.response.data.message))
  }
}
type updateNurseAction = {
  type: string
  payload: {
    key: string
    form: FormInstance<any>
  }
}

export function* handleSetUpdateNurseData(
  actions: updateNurseAction
): SagaIterator<void> {
  const response = yield call(getNurseData, actions.payload.key)
  const { data } = response
  for (const key in data) {
    if (data[key] === null || data[key] === undefined) {
      data[key] = ''
    }
  }
  const unmodifiedData: GetNurseDataType = data
  let newNurseData: Nurse = {
    nurseId: unmodifiedData.nurseId,
    nurseKey: unmodifiedData.nurseKey,
    emailId: unmodifiedData.email,
    isActive: unmodifiedData.isActive,
    title: unmodifiedData.title,
    firstName: unmodifiedData.firstName,
    lastName: unmodifiedData.lastName,
    isSupervisor: unmodifiedData.isSupervisor,
    jobTitle: unmodifiedData.jobTitle,
    phonePrimary: unmodifiedData.phone1,
    phoneSecondary: unmodifiedData.phone2,
  }

  yield put(
    setNurseForUpdateSuccess({
      form: actions.payload.form,
      nurseData: newNurseData,
    })
  )
}

export function* watcherSaga() {
  yield takeLatest(GET_NURSE, handleGetNurseData)
  yield takeLatest(GET_NURSES, handleGetNursesData)
  yield takeLatest(ADD_NURSE, handleAddNurseData)
  yield takeLatest(DELETE_NURSE, handleDeleteNurseData)
  yield takeLatest(UPDATE_NURSE, handleUpdateNurseData)
  yield takeLatest(ACTIVATE_NURSE, handleActivateNurseData)
  yield takeLatest(SET_UPDATE_NURSE, handleSetUpdateNurseData)
  yield takeLatest(CHANGE_NURSE_ROLE, handleChangeNurseRoleData)
}

export const nurseSaga = [fork(watcherSaga)]
